import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { OrganizationModels } from '@share-models';

export const OrganizationActions = createActionGroup({
  source: 'ORGANIZATION',
  events: {
    'Reset to Initial state': emptyProps(),
    'Complete Organization Switch': props<{ organizationId: string }>(),
    'Get Active Organization': emptyProps(),
    'Set Active Organization': props<{
      activeOrganization: OrganizationModels.OrganizationDocument;
    }>(),
    'Get Active Organization Fail': emptyProps(),
    'Load Switched Active Organization': props<{ organizationId: string }>(),
    'Set Switched Active Organization': props<{
      organizationId: string;
      activeOrganization: OrganizationModels.OrganizationDocument;
    }>(),
    'Get My Organizations': emptyProps(),
    'Get My Organizations Success': props<{
      userOrganizations: OrganizationModels.UserOrganizationDropDown[];
    }>(),
    'Get My Organizations Fail': emptyProps(),
  },
});
